var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgSuperhero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA754"
    },
    d: "M86.757,311.954v152.133c0,4.143,3.358,7.5,7.5,7.5c4.142,0,7.5-3.357,7.5-7.5V311.954H86.757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCB63"
    },
    d: "M37.506,311.954v152.133c0,4.143,3.358,7.5,7.5,7.5s7.5-3.357,7.5-7.5V311.954H37.506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#116F97"
    },
    d: "M410.258,311.954v152.133c0,4.143,3.357,7.5,7.5,7.5c4.143,0,7.5-3.357,7.5-7.5V311.954H410.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#084F6D"
    },
    d: "M459.509,311.954v152.133c0,4.143,3.357,7.5,7.5,7.5c4.143,0,7.5-3.357,7.5-7.5V311.954H459.509z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2DADE3"
    },
    points: "101.752,224.082 101.757,304.083 61.751,314.084 81.752,224.082 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8D7E"
    },
    d: "M69.621,134.08v60.001c16.57,0,30.001-13.43,30.001-30.001S86.192,134.08,69.621,134.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB4A9"
    },
    d: "M69.621,134.08c5.53,0,10,13.43,10,30.001s-4.47,30.001-10,30.001 c-16.56,0-30.001-13.43-30.001-30.001S53.061,134.08,69.621,134.08z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#49C9FF"
    },
    points: "81.752,224.082 81.752,314.084 37.506,304.083 37.501,224.082 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA754"
    },
    d: "M81.757,304.083l-12.13,40.001c17.75,0,32.131-14.38,32.131-32.131v-7.87H81.757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCB63"
    },
    d: "M81.757,304.083v7.87c0,17.75-5.43,32.131-12.13,32.131c-17.74,0-32.121-14.38-32.121-32.131v-7.87 H81.757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2DADE3"
    },
    d: "M131.753,344.084c-4.142,0-7.5-3.357-7.5-7.5v-82.502c0-12.406-10.093-22.5-22.5-22.5H37.501 c-12.407,0-22.5,10.094-22.5,22.5v82.502c0,4.143-3.358,7.5-7.5,7.5s-7.5-3.357-7.5-7.5v-82.502 c0-20.678,16.822-37.501,37.501-37.501h64.251c20.678,0,37.501,16.822,37.501,37.501v82.502 C139.253,340.726,135.895,344.084,131.753,344.084z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFA754"
    },
    points: "474.509,224.082 474.509,304.083 434.508,314.084 454.509,224.082 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C27749"
    },
    d: "M442.379,134.08v60.001c16.57,0,30.001-13.43,30.001-30.001S458.949,134.08,442.379,134.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E18F4E"
    },
    d: "M442.379,134.08c5.53,0,10,13.43,10,30.001s-4.47,30.001-10,30.001 c-16.56,0-30.001-13.43-30.001-30.001S425.818,134.08,442.379,134.08z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCB63"
    },
    points: "454.509,224.082 454.509,314.084 410.258,304.083 410.258,224.082 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#084F6D"
    },
    d: "M454.509,304.083l-12.13,40.001c17.75,0,32.131-14.38,32.131-32.131v-7.87H454.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#116F97"
    },
    d: "M454.509,304.083v7.87c0,17.75-5.43,32.131-12.13,32.131c-17.74,0-32.121-14.38-32.121-32.131v-7.87 H454.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA754"
    },
    d: "M504.5,344.084c-4.143,0-7.5-3.357-7.5-7.5v-82.502c0-12.406-10.094-22.5-22.5-22.5h-64.241 c-12.406,0-22.5,10.094-22.5,22.5v82.502c0,4.143-3.357,7.5-7.5,7.5c-4.143,0-7.5-3.357-7.5-7.5v-82.502 c0-20.678,16.822-37.501,37.501-37.501h64.241c20.678,0,37.501,16.822,37.501,37.501v82.502 C512,340.726,508.643,344.084,504.5,344.084z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF301B"
    },
    d: "M334.177,245.38l-34.779-81.171h-13.812l34.671,214.874h30.001v-55.001 C350.257,296.14,344.527,269.536,334.177,245.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4128"
    },
    d: "M309.295,245.38l-23.708-81.171h-72.973l-34.779,81.171c-10.349,24.155-16.08,50.76-16.08,78.703 v55.001h158.503v-55.001C320.256,296.14,316.35,269.536,309.295,245.38z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1990C2"
    },
    points: "233.505,280.614 218.504,280.614 218.504,444.086 233.505,414.086 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4128"
    },
    d: "M196.004,414.086v52.095l-12.372,4.124c-3.93,1.31-6.053,5.558-4.744,9.487 c1.048,3.143,3.974,5.13,7.114,5.13c0.786,0,1.586-0.125,2.373-0.387l40.001-13.333c3.063-1.021,5.128-3.887,5.128-7.115v-50.001 H196.004z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#116F97"
    },
    points: "278.505,280.614 293.506,280.614 293.506,444.086 278.505,414.086 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4128"
    },
    d: "M316.006,414.086v52.095l12.372,4.124c3.93,1.31,6.053,5.558,4.744,9.487 c-1.048,3.143-3.974,5.13-7.114,5.13c-0.786,0-1.586-0.125-2.373-0.387l-40.001-13.333c-3.063-1.021-5.128-3.887-5.128-7.115 v-50.001H316.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#116F97"
    },
    d: "M256.005,207.082v105.002c24.853,0,45.001-20.147,45.001-45.001L256.005,207.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1990C2"
    },
    d: "M271.005,267.083v-60.001l-60.001,60.001c0,24.853,20.147,45.001,45.001,45.001 C264.289,312.084,271.005,291.935,271.005,267.083z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCB63"
    },
    points: "271.005,267.083 301.006,267.083 301.006,237.082 241.005,207.082 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE2A8"
    },
    points: "271.005,267.083 211.004,267.083 211.004,237.082 271.005,207.082 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#49C9FF"
    },
    d: "M127.502,72.079c4.142,0,7.5,3.358,7.5,7.5v11.5c0,41.908,34.094,76.001,76.001,76.001h30.001v15 h-30.001c-50.179,0-91.002-40.823-91.002-91.002v-11.5C120.002,75.437,123.36,72.079,127.502,72.079z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2DADE3"
    },
    d: "M384.508,72.079c-4.142,0-7.5,3.358-7.5,7.5v11.5c0,41.908-34.094,76.001-76.001,76.001h-30.001v15 h30.001c50.179,0,91.002-40.823,91.002-91.002v-11.5C392.008,75.437,388.65,72.079,384.508,72.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2DADE3"
    },
    d: "M281.005,147.08h-30.001l20,90.002h30.001v-70.001C301.006,156.035,292.052,147.08,281.005,147.08z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#49C9FF"
    },
    d: "M251.005,147.08h-20c-11.046,0-20,8.954-20,20v70.001h60.001v-70.001 C271.005,156.035,262.051,147.08,251.005,147.08z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF6337"
    },
    cx: 206.004,
    cy: 92.081,
    r: 25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB4A9"
    },
    d: "M270.097,56.626l-14.092,60.454c24.853,0,45.001-20.147,45.001-45.001L270.097,56.626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD9D4"
    },
    d: "M271.005,72.079c0-5.429-0.321-10.634-0.908-15.453l-41.096-20.546 c-10.927,8.21-17.997,21.278-17.997,36c0,24.853,20.147,45.001,45.001,45.001C264.289,117.08,271.005,96.931,271.005,72.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4128"
    },
    d: "M256.005,27.078l14.899,39.833c9.413,3.341,19.543,5.168,30.102,5.168 C301.006,47.225,280.858,27.078,256.005,27.078z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6337"
    },
    d: "M256.005,27.078c-10.132,0-19.481,3.35-27.004,9.002c10.532,14.02,25.066,24.856,41.902,30.832 C270.049,44.492,263.706,27.078,256.005,27.078z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperhero);
export default __webpack_public_path__ + "static/media/superhero.4805c7f7322d3ed08574f14efb6e4d0b.svg";
export { ForwardRef as ReactComponent };